<div class="parked-cars-wrapper">
    <h2>Parkerade bilar</h2>
    <p class="description">De bilar som har ankommit till parkeringen och ej lämnat.</p>

    <!-- Resource toggle -->
    <div class="resource-and-total-wrapper">
        <mat-button-toggle-group *ngIf="resources.length" #group="matButtonToggleGroup"
            value="{{resources[0].resourceId}}" (change)="changeResourceType(group.value)">
            <mat-button-toggle *ngFor="let resource of resources" value="{{resource.resourceId}}"
                name="resource">{{resource.label}}</mat-button-toggle>
        </mat-button-toggle-group>

        <div class="total-parked-wrapper" title="Totalt antal bilar ({{activeResourceName()}})">
            <mat-icon>directions_car</mat-icon>
            <span> {{totalBookings}}</span>
        </div>
    </div>

    <input class="search-input" type="search" placeholder="Sök på reg.nr eller bokningsnr." [formControl]="searchInput"
        data-test="search-all-bookings" spellcheck="false" autocomplete="off" />

    <mat-radio-group class="filters" [formControl]="serviceTypeFilter">
        <mat-label>
            <h5>Filter:</h5>
        </mat-label>
        <mat-radio-button color="primary" value="{{undefined}}" checked>Alla</mat-radio-button>
        <mat-radio-button color="primary" value="CAR_WASH">Tvätt</mat-radio-button>
        <mat-radio-button *ngIf="isGarage()" color="primary" value="GARAGE">Laddning</mat-radio-button>
        <mat-radio-button color="primary" value="WORKSHOP">Verkstad</mat-radio-button>
    </mat-radio-group>

    <mat-paginator [length]="totalBookings" [pageIndex]="pageIndex" [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" aria-label="Välj sida"
        (page)="paginator($event)">
    </mat-paginator>

    <div class="spinner-table-wrapper" *ngIf="showSpinner">
        <mat-spinner diameter="70"></mat-spinner>
    </div>

    <app-bookings-table *ngIf="!showSpinner" [bookings]="bookings" topic="parked" [sortOrder]="sortOrder"
        [showParkTimeColumn]="true">
    </app-bookings-table>

    <div class="empty-content" *ngIf="bookings.length <= 0 && searchInput.value">
        <p>Kan inte hitta någon bokning<span *ngIf="searchInput.value"> som matchar "{{searchInput.value}}"</span>.</p>
    </div>

    <div class="empty-content" *ngIf="bookings.length <= 0 && !searchInput.value">
        <p>Kunde inte hitta några bokningar.</p>
    </div>

    <mat-paginator [length]="totalBookings" [pageIndex]="pageIndex" [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" aria-label="Välj sida"
        (page)="paginator($event)">
    </mat-paginator>
</div>